<div *ngIf="stage === 'introduction'" fxLayout="column" fxLayoutGap="24px">
  <h2>Connect a bank account</h2>

  <span>
    Add a personal or business bank account to start collecting direct bookings. After successfully completing the
    Know-Your-Customer (KYC) requirements we will start transferring payouts directly into your account, in most cases
    24 hours after check-in.
  </span>

  <div fxLayoutAlign="end center" class="intro-buttons">
    <sbnb-button label="Add an account" (clicked)="stage = 'entity_type'"></sbnb-button>
  </div>
</div>

<div *ngIf="stage === 'entity_type'" fxLayout="column" fxLayoutGap="24px">
  <h2>Is your bank account registered to an individual or an organization?</h2>

  <mat-radio-group class="radio-group" [(ngModel)]="payoutMethod.legal_entity">
    <mat-radio-button value="individual">Individual</mat-radio-button>
    <mat-radio-button value="organization">
      <div fxLayout="column" fxLayoutGap="4px">
        <span>Organization</span>
        <span class="text__small night-lighter">
          A privately held company, public company, non-profit, or governmental organization.
        </span>
      </div>
    </mat-radio-button>
  </mat-radio-group>

  <div fxLayoutAlign="end center">
    <sbnb-button
      label="Continue"
      [disabled]="!payoutMethod.legal_entity"
      (clicked)="progressFromEntityType()"></sbnb-button>
  </div>
</div>

<div *ngIf="stage === 'individual_bank_account_owner'" fxLayout="column" fxLayoutGap="24px">
  <h2>Who is the bank account owner?</h2>

  <div fxLayout fxLayoutGap="24px">
    <div fxLayout="column" fxFlex>
      <label for="first_name">First name</label>
      <mat-form-field class="nopadding">
        <input matInput type="text" [(ngModel)]="payoutMethod.first_name" />
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex>
      <label for="last_name">Last name</label>
      <mat-form-field class="nopadding">
        <input matInput type="text" [(ngModel)]="payoutMethod.last_name" />
      </mat-form-field>
    </div>
  </div>

  <ng-template [ngTemplateOutlet]="telInput"></ng-template>

  <div fxLayout="column" fxFlex>
    <label for="first_name">Individual's country of residence</label>
    <mat-form-field class="nopadding">
      <mat-select [(ngModel)]="payoutMethod.country">
        <mat-option *ngFor="let country of ADYEN_ALLOWABLE_COUNTRIES | keyvalue" [value]="country.key">
          {{ country.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayoutAlign="space-between center">
    <sbnb-button label="Go back" type="secondary" (clicked)="stage = 'entity_type'"></sbnb-button>
    <sbnb-button
      label="Continue"
      [disabled]="!payoutMethod.first_name || !payoutMethod.last_name || !payoutMethod.country"
      (clicked)="progressFromBankDetails()"></sbnb-button>
  </div>
</div>

<div *ngIf="stage === 'organization_bank_account_owner'" fxLayout="column" fxLayoutGap="24px">
  <h2>Who is the bank account owner?</h2>

  <div fxLayout="column" fxFlex>
    <label for="first_name">Legal name of the organization</label>
    <mat-form-field class="nopadding">
      <input matInput type="text" [(ngModel)]="payoutMethod.legal_name" />
    </mat-form-field>
  </div>

  <ng-template [ngTemplateOutlet]="telInput"></ng-template>

  <div fxLayout="column" fxFlex>
    <label for="first_name">Country of registration</label>
    <mat-form-field class="nopadding">
      <mat-select [(ngModel)]="payoutMethod.country">
        <mat-option *ngFor="let country of ADYEN_ALLOWABLE_COUNTRIES | keyvalue" [value]="country.key">
          {{ country.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="column" fxFlex>
    <label for="first_name">Primary place of business</label>
    <mat-form-field class="nopadding">
      <mat-select [(ngModel)]="payoutMethod.country">
        <mat-option *ngFor="let country of ADYEN_ALLOWABLE_COUNTRIES | keyvalue" [value]="country.key">
          {{ country.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayoutAlign="space-between center">
    <sbnb-button label="Go back" type="secondary" (clicked)="stage = 'entity_type'"></sbnb-button>
    <sbnb-button
      label="Continue"
      [disabled]="!payoutMethod.legal_name || !payoutMethod.country"
      (clicked)="progressFromBankDetails()"></sbnb-button>
  </div>
</div>

<div *ngIf="stage === 'property_selection'" fxLayout="column" fxLayoutGap="36px">
  <h2>Which properties will pay out to this account?</h2>

  <sbnb-property-selection
    [allPropertiesEnabled]="true"
    [border]="true"
    [listHeight]="280"
    (propertiesChange)="setProperties($event)"></sbnb-property-selection>

  <sbnb-default-payout-method-option
    [isDefault]="payoutMethod.all_properties"
    (isDefaultChanged)="updateDefaultPayoutMethod($event)"></sbnb-default-payout-method-option>

  <div fxLayoutAlign="space-between center">
    <sbnb-button label="Go back" type="secondary" (clicked)="progressFromEntityType()"></sbnb-button>
    <sbnb-button label="Continue" (clicked)="checkForOverlappingProperties()"></sbnb-button>
  </div>
</div>

<div *ngIf="stage === 'property_warning'">
  <sbnb-property-overlap-warning
    [overlappingProperties]="overlappingProperties"
    (backClicked)="stage = 'property_selection'"
    (continueClicked)="progressToSaving()"></sbnb-property-overlap-warning>
</div>

<div
  *ngIf="stage === 'saving'"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="36px"
  class="saving-container">
  <mat-spinner [diameter]="36"></mat-spinner>
  <span>Setting up your account</span>
</div>

<div *ngIf="stage === 'success'" fxLayout="column" fxLayoutGap="36px" class="saving-container">
  <div fxLayout="column" fxLayoutGap="18px">
    <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
      <sbnb-icon icon="check" class="text-grass-darker success-icon"></sbnb-icon>
      <span>Account created</span>
    </h2>
    <span>You can now accept Direct bookings for properties tied to this payout method.</span>

    <span>You need to complete a verification process before Hospitable can payout funds to your bank account.</span>
  </div>

  <div fxLayoutAlign="space-between center">
    <a [routerLink]="['/direct/payouts']">
      <sbnb-button label="Do this later" type="secondary"></sbnb-button>
    </a>

    <a [routerLink]="['/direct/payouts']">
      <sbnb-button
        [type]="redirect ? 'secondary' : 'primary'"
        label="Verify my account"
        (click)="verifyClicked()"></sbnb-button>
    </a>
  </div>
</div>

<ng-template #telInput>
  <div fxLayout="column" fxFlex>
    <label for="mobile_phone">Mobile number</label>

    <mat-form-field class="fw">
      <ngx-mat-intl-tel-input
        [enablePlaceholder]="true"
        [preferredCountries]="['us']"
        [onlyCountries]="['us', 'au', 'gb']"
        name="mobile_phone"
        #phone
        [(ngModel)]="payoutMethod.phone"></ngx-mat-intl-tel-input>
      <mat-hint>Eg. {{ phone.selectedCountry.placeHolder }}</mat-hint>
    </mat-form-field>
  </div>
</ng-template>
